export default {
  xxxsmall: '8px',
  xxsmall: '12px',
  xsmall: '16px',
  small: '24px',
  medium: '32px',
  large: '40px',
  xlarge: '48px',
  xxlarge: '56px',
} as const;
